import React, { Component } from 'react';
import { Grid, Row, Col, Modal, Form, FormGroup, FormControl, ControlLabel, ButtonToolbar, Button } from 'react-bootstrap';

import { HandleDialog } from '../../HandleDialog';
import { ComponentStyles } from './componentStyles/ComponentStyles';
import { SimpleTextDataIdentifier } from './dataIdentifiers/SimpleTextDataIdentifier';
import { ImageDataIdentifier } from './dataIdentifiers/ImageDataIdentifier';
import { QrCodeDataIdentifier } from './dataIdentifiers/QrCodeDataIdentifier';
import { DayTimesheetDataIdentifier } from './dataIdentifiers/DayTimesheetDataIdentifier';
import { VerticalDayTimesheetDataIdentifier } from './dataIdentifiers/VerticalDayTimesheetDataIdentifier';
import { LineInformationDataIdentifier } from './dataIdentifiers/LineInformationDataIdentifier';
import { HorizontalStopsListDataIdentifier } from './dataIdentifiers/HorizontalStopsListDataIdentifier';
import { VerticalStopsListDataIdentifier } from './dataIdentifiers/VerticalStopsListDataIdentifier';
import { HorizontalTabularDayTimesheetDataIdentifier } from './dataIdentifiers/HorizontalTabularDayTimesheetDataIdentifier';
import { VerticalTabularDayTimesheetDataIdentifier } from './dataIdentifiers/VerticalTabularDayTimesheetDataIdentifier';
import { ExceptionsDataIdentifier } from './dataIdentifiers/ExceptionsDataIdentifier';
import { DayTimesheetParameters } from './parameters/DayTimesheetParameters';
import { GlobalParameters } from './parameters/GlobalParameters';

export class ComponentConfigurationProperties extends Component {
    constructor(props) {
        super(props);

        const infoElements = {
            simpletext: SimpleTextDataIdentifier,
            image: ImageDataIdentifier,
            qrcode: QrCodeDataIdentifier,
            daytimesheet: DayTimesheetDataIdentifier,
            compactdaytimesheet: DayTimesheetDataIdentifier,
            verticaldaytimesheet: VerticalDayTimesheetDataIdentifier,
            horizontaltabulardaytimesheet: HorizontalTabularDayTimesheetDataIdentifier,
            verticaltabulardaytimesheet: VerticalTabularDayTimesheetDataIdentifier,
            lineinformation: LineInformationDataIdentifier,
            horizontalstopslist: HorizontalStopsListDataIdentifier,
            verticalstopslist: VerticalStopsListDataIdentifier,
            exceptions: ExceptionsDataIdentifier,
        };
        const parametersElements = {
            daytimesheet: DayTimesheetParameters,
            compactdaytimesheet: DayTimesheetParameters,
            verticaldaytimesheet: DayTimesheetParameters,
            horizontaltabulardaytimesheet: DayTimesheetParameters,
            verticaltabulardaytimesheet: DayTimesheetParameters,
            lineinformation: GlobalParameters,
            horizontalstopslist: GlobalParameters,
            verticalstopslist: GlobalParameters,
        };
        const infoConfiguration = {
            enable: false,
            showModal: false,
            element: null
        };
        const parametersConfiguration = {
            enable: false,
            showModal: false,
            element: null
        }

        // Add Info / Configuration
        if (undefined !== infoElements[this.props.component.type.toLowerCase()]) {
            infoConfiguration.enable = true;
            infoConfiguration.element = infoElements[this.props.component.type.toLowerCase()];
        }

        if (undefined !== parametersElements[this.props.component.type.toLowerCase()]) {
            parametersConfiguration.enable = true;
            parametersConfiguration.element = parametersElements[this.props.component.type.toLowerCase()];
        }

        this.state = {
            component: {
                id: this.props.component.id,
                internalId: this.props.component.internalId,
                modified: this.props.component.modified,
                width: this.props.component.width,
                height: this.props.component.height,
                positionX: this.props.component.positionX,
                positionY: this.props.component.positionY,
                positionZ: this.props.component.positionZ,
                dataIdentifier: this.props.component.dataIdentifier,
                configuration: this.props.component.configuration,
                parameters: this.props.component.parameters,
                type: this.props.component.type,
                fonts: this.props.component.fonts.slice(0),
                backgrounds: this.props.component.backgrounds.slice(0),
                margins: this.props.component.margins.slice(0),
                circleElements: this.props.component.circleElements.slice(0)
            },
            inputStyles: {
                width: null,
                height: null,
                positionX: null,
                positionY: null,
                positionZ: null
            },
            configurations: {
                infoElements: infoElements,
                parametersElements: parametersElements,
                infoConfiguration: infoConfiguration,
                parametersConfiguration: parametersConfiguration,
                showStylesConfiguration: false

            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        };
    }

    // -----------------------

    componentWillReceiveProps(nextProps) {
        const { component } = nextProps;
        const { configurations } = this.state;

        // Adicional Info / Configuration
        if (undefined !== configurations.infoElements[component.type.toLowerCase()]) {
            configurations.infoConfiguration.enable = true;
            configurations.infoConfiguration.element = configurations.infoElements[component.type.toLowerCase()];
        }
        else {
            configurations.infoConfiguration.enable = false;
            configurations.infoConfiguration.element = null;
        }

        // Parameters
        if (undefined !== configurations.parametersElements[component.type.toLowerCase()]) {
            configurations.parametersConfiguration.enable = true;
            configurations.parametersConfiguration.element = configurations.parametersElements[component.type.toLowerCase()];
        }
        else {
            configurations.parametersConfiguration.enable = false;
            configurations.parametersConfiguration.element = null;
        }

        this.setState({
            component: {
                id: component.id,
                internalId: component.internalId,
                modified: component.modified,
                width: component.width,
                height: component.height,
                positionX: component.positionX,
                positionY: component.positionY,
                positionZ: component.positionZ,
                dataIdentifier: component.dataIdentifier,
                configuration: component.configuration,
                parameters: component.parameters,
                type: component.type,
                fonts: component.fonts.slice(0),
                backgrounds: component.backgrounds.slice(0),
                margins: component.margins.slice(0),
                circleElements: component.circleElements.slice(0)
            },
            configurations: configurations
        });
    }

    // -----------------------

    onSave() {
        if (null !== this.props.onSaveComponentProperties && undefined !== this.props.onSaveComponentProperties) {
            const { component } = this.state;

            const inputStyles = {
                width: null,
                height: null,
                positionX: null,
                positionY: null,
                positionZ: null
            }

            if (0 >= component.width.length) {
                inputStyles.width = "error"
            }
            if (0 >= component.height.length) {
                inputStyles.height = "error"
            }
            if (0 >= component.positionX.length) {
                inputStyles.positionX = "error"
            }
            if (0 >= component.positionY.length) {
                inputStyles.positionY = "error"
            }
            if (0 >= component.positionZ.length) {
                inputStyles.positionZ = "error"
            }

            this.setState({
                inputStyles: inputStyles
            });

            if (null === inputStyles.width && null === inputStyles.height && null === inputStyles.positionX && null === inputStyles.positionY && null === inputStyles.positionZ) {
                this.props.onSaveComponentProperties(component);
            }
        }
    }

    onParameter() {
        const { component } = this.state;

        if (undefined !== component.internalId && null !== component.internalId) {
            const { configurations } = this.state;

            configurations.parametersConfiguration.showModal = true;

            this.setState({
                configurations: configurations
            });
        }
    }

    onHideParametersConfigurationModal() {
        const { configurations } = this.state;

        configurations.parametersConfiguration.showModal = false;

        this.setState({
            configurations: configurations
        });
    }

    onConfigureInfo() {
        const { component } = this.state;

        if (undefined !== component.internalId && null !== component.internalId) {
            const { configurations } = this.state;

            configurations.infoConfiguration.showModal = true;

            this.setState({
                configurations: configurations
            });
        }
    }

    onHideInfoConfigurationModal() {
        const { configurations } = this.state;

        configurations.infoConfiguration.showModal = false;

        this.setState({
            configurations: configurations
        });
    }

    onConfigureStyles() {
        const { component } = this.state;

        if (undefined !== component.internalId && null !== component.internalId) {
            const { configurations } = this.state;

            configurations.showStylesConfiguration = true;

            this.setState({
                configurations: configurations
            });
        }
    }

    onHideStylesConfigurationModal() {
        const { configurations } = this.state;

        configurations.showStylesConfiguration = false;

        this.setState({
            configurations: configurations
        });
    }

    // -----------------------

    onDeleteSelectedComponent(component) {
        this.setState({
            dialog: {
                show: true,
                message: "Tem a certeza que pretende eliminar o componente selecionado?",
                style: "warning",
                icon: "alert",
                title: "Aviso",
                argument: {
                    component: component
                }
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        if (isToExecute) {
            this.props.onDeleteSelectedComponent(argument.component);
        }

        this.setState({
            dialog: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: "",
                argument: undefined
            }
        });
    }

    // -----------------------

    onSelectData(dataId, isToClose) {
        const { component } = this.state;

        this.props.onComponentChangeValue({ target: { value: `${dataId}` } }, "dataIdentifier");

        component.dataIdentifier = dataId;
        component.modified = true;

        if (isToClose) {
            this.onHideInfoConfigurationModal();
        }

        this.setState({
            component: component
        });
    }

    onConfigureData(configuration, isToClose) {
        const { component } = this.state;

        this.props.onComponentChangeValue({ target: { value: `${configuration}` } }, "configuration");

        component.configuration = configuration;
        component.modified = true;

        if (isToClose) {
            this.onHideInfoConfigurationModal();
        }

        this.setState({
            component: component
        });
    }

    onParameterData(parameters, isToClose) {
        const { component } = this.state;

        this.props.onComponentChangeValue({ target: { value: parameters } }, "parameters");

        component.parameters = parameters;
        component.modified = true;

        if (isToClose) {
            this.onHideParametersConfigurationModal();
        }

        this.setState({
            component: component
        });
    }

    onUpdateStyles(data, target) {
        const { component } = this.state;

        const styles = data.map(d => Object.assign({}, d));
        this.props.onComponentChangeValue({ target: { value: styles } }, target);

        component[target] = styles;
        this.setState({
            component: component
        });
    }

    // -----------------------

    renderParametersElementButton(configuration) {
        if (!configuration.enable) {
            return null;
        }

        return (
            <Button bsStyle="default" onClick={() => this.onParameter()}>PARÂMETROS</Button>
        );
    }

    renderParametersElementModal(configuration, parameters) {
        if (!configuration.enable || !configuration.showModal) {
            return null;
        }

        return (
            <Modal show={configuration.showModal}
                bsSize="large" >
                <Modal.Header>
                    <Modal.Title>GERAÇÃO</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        React.createElement(
                            configuration.element,
                            {
                                parameters: parameters,
                                onParameterData: (a, b) => this.onParameterData(a, b),
                                onCancel: () => this.onHideParametersConfigurationModal()
                            })
                    }
                </Modal.Body>
            </Modal>
        );
    }

    renderSpecificInfoElementButton(configuration) {
        if (!configuration.enable) {
            return null;
        }

        return (
            <Button bsStyle="default" onClick={() => this.onConfigureInfo()}>CONFIGURAÇÃO</Button>
        );
    }

    renderSpecificInfoElementModal(configuration, dataIdentifier, componentConfiguration) {
        if (!configuration.enable || !configuration.showModal) {
            return null;
        }

        return (
            <Modal show={configuration.showModal}
                bsSize="large" >
                <Modal.Header>
                    <Modal.Title>CONFIGURAÇÃO</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        React.createElement(
                            configuration.element,
                            {
                                selectedData: dataIdentifier,
                                configuration: componentConfiguration,
                                onSelectData: (a, b) => this.onSelectData(a, b),
                                onConfigureData: (a, b) => this.onConfigureData(a, b),
                                onCancel: () => this.onHideInfoConfigurationModal()
                            })
                    }
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        const { component, inputStyles, configurations, dialog } = this.state;

        return (
            <div className="margin-top-15">
                <Grid fluid>
                    <Row>
                        <Col className="no-padding-left" sm={12}>
                            <div className="control-label">Configuração Elemento</div>
                        </Col>
                    </Row>
                    <Row className="margin-top-15">
                        <Col className="no-padding-left" sm={12}>
                            <Form horizontal>
                                <div style={{ display: "flex" }}>
                                    <div style={{ width: "50%" }}>
                                        <FormGroup bsSize="small"
                                            controlId="formComponentPositionX"
                                            validationState={inputStyles.positionX} >
                                            <Col componentClass={ControlLabel} sm={4}>X</Col>
                                            <Col sm={8}>
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Posição no Eixo X"
                                                    value={component.positionX}
                                                    onChange={(e) => this.props.onComponentChangeValue(e, 'positionX')} />
                                            </Col>
                                        </FormGroup>
                                    </div>

                                    <div style={{ width: "50%" }}>
                                        <FormGroup bsSize="small"
                                            controlId="formComponentWidth"
                                            validationState={inputStyles.width} >
                                            <Col componentClass={ControlLabel} sm={4}>L</Col>
                                            <Col sm={8}>
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Largura do Elemento"
                                                    value={component.width}
                                                    onChange={(e) => this.props.onComponentChangeValue(e, 'width')} />
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </div>

                                <div style={{ display: "flex" }}>
                                    <div style={{ width: "50%" }}>
                                        <FormGroup bsSize="small"
                                            controlId="formComponentPositionY"
                                            validationState={inputStyles.positionY} >
                                            <Col componentClass={ControlLabel} sm={4}>Y</Col>
                                            <Col sm={8}>
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Posição no Eixo Y"
                                                    value={component.positionY}
                                                    onChange={(e) => this.props.onComponentChangeValue(e, 'positionY')} />
                                            </Col>
                                        </FormGroup>
                                    </div>

                                    <div style={{ width: "50%" }}>
                                        <FormGroup bsSize="small"
                                            controlId="formComponentHeight"
                                            validationState={inputStyles.height} >
                                            <Col componentClass={ControlLabel} sm={4}>A</Col>
                                            <Col sm={8}>
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Altura do Elemento"
                                                    value={component.height}
                                                    onChange={(e) => this.props.onComponentChangeValue(e, 'height')} />
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </div>

                                <div style={{ display: "flex" }}>
                                    <div style={{ width: "50%" }}>
                                        <FormGroup bsSize="small"
                                            controlId="formComponentPositionZ"
                                            validationState={inputStyles.positionZ} >
                                            <Col componentClass={ControlLabel} sm={4}>Z</Col>
                                            <Col sm={8}>
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Posição no Eixo Z"
                                                    value={component.positionZ}
                                                    onChange={(e) => this.props.onComponentChangeValue(e, 'positionZ')} />
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </div>

                                <ButtonToolbar>
                                    {this.renderParametersElementButton(configurations.parametersConfiguration)}
                                    {this.renderSpecificInfoElementButton(configurations.infoConfiguration)}
                                    <Button bsStyle="default" onClick={() => this.onConfigureStyles()}>ESTILOS</Button>
                                    <Button bsStyle="default"
                                        className="pull-left"
                                        onClick={() => this.onDeleteSelectedComponent(component)}>
                                        ELIMINAR ELEMENTO
                                    </Button>
                                </ButtonToolbar>

                                {this.renderParametersElementModal(configurations.parametersConfiguration, component.parameters)}
                                {this.renderSpecificInfoElementModal(configurations.infoConfiguration, component.dataIdentifier, component.configuration)}
                            </Form>
                        </Col>
                    </Row>
                </Grid>

                <Modal
                    enforceFocus={false}
                    show={configurations.showStylesConfiguration}
                    bsSize="large"
                    onHide={() => this.onHideStylesConfigurationModal()} >
                    <Modal.Header
                        closeLabel="Fechar"
                        closeButton >
                        <Modal.Title>Estilos</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ComponentStyles
                            fonts={component.fonts.slice(0)}
                            backgrounds={component.backgrounds.slice(0)}
                            circleElements={component.circleElements.slice(0)}
                            margins={component.margins.slice(0)}
                            componentType={component.type}
                            onUpdateStyles={(a, b) => this.onUpdateStyles(a, b)} />
                    </Modal.Body>
                </Modal>

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/ComponentConfigurationProperties.js